module.exports = __webpack_public_path__ + "img/selected5-min.7e7c12e7.png";